import React, { useEffect, useState, useRef } from "react";
import Map from './images/map.png'
import useIntersectionObserver from "./home-animation";

const HomeCountries = () => {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
    const [counted, setCounted] = useState(false);
    const countRefs = useRef([]);

    useEffect(() => {
        const handleScroll = () => {
            if (!counted && isVisible1 && isVisible2) {
                countRefs.current.forEach((ref, index) => {
                    const countTo = parseInt(ref.getAttribute("data-count"), 10);
                    animateCount(ref, countTo, 2000);
                });
                setCounted(true); // Update the state to prevent animation on subsequent scrolls
            }
        };

        const animateCount = (element, countTo, duration) => {
            const start = parseInt(element.innerText, 10);
            let startTime = null;

            const step = (currentTime) => {
                if (!startTime) {
                    startTime = currentTime;
                }

                const progress = Math.min((currentTime - startTime) / duration, 1);
                const value = Math.floor(progress * (countTo - start) + start);
                element.innerText = value;

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };

            requestAnimationFrame(step);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [counted, isVisible1, isVisible2]);

    return (
        <div className="home-countries">
            <div className="outer-container">
                <div className="d-lg-flex">
                    <div className="home-leftcontent">
                        <div className={`home-subhead ${isVisible1 ? 'animate__fadeInRight' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef1}>
                        Trusted by Businesses Worldwide
                        </div>
                        <p className="pt-3 pb-5 main-para">
                        Our platform facilitates seamless connections and collaborations between businesses, providing effective solutions for talent acquisition and organizational growth.
                        </p>
                        <div className={`home-numbers ${isVisible2 ? 'animate__fadeInUp' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef2}>
                            <div className="home-separators">
                                <div className="home-ink">
                                    <span ref={(el) => (countRefs.current[0] = el)} data-count="380">0</span><span>K</span>
                                </div>
                                <div className="home-content-ink">
                                    Active Members
                                </div>
                            </div>
                            <div className="home-separators">
                                <div className="home-ink">
                                    <span ref={(el) => (countRefs.current[1] = el)} data-count="27">0</span><span>K</span>
                                </div>
                                <div className="home-content-ink">
                                    Companies Available
                                </div>
                            </div>
                            <div className="home-separators">
                                <div className="home-ink">
                                    <span ref={(el) => (countRefs.current[2] = el)} data-count="150">0</span><span>+</span>
                                </div>
                                <div className="home-content-ink">
                                    Expert Agents
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="home-map-container">
                        <img src={Map} alt="Map" className="img-fluid" width="727" height="466"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeCountries;
